import React from 'react';
import { Card } from 'react-bootstrap';
import '../s_csvc-css/beta.css'; 

import Carousel from 'react-bootstrap/Carousel';
//import ExampleCarouselImage from 'components/ExampleCarouselImage';
import Slide01 from '../m_assets/img/slideshow-presentazione/Diapositiva1.PNG'
import Slide02 from '../m_assets/img/slideshow-presentazione/Diapositiva2.PNG'
import Slide03 from '../m_assets/img/slideshow-presentazione/Diapositiva3.PNG'
import Slide04 from '../m_assets/img/slideshow-presentazione/Diapositiva4.PNG'
import Slide05 from '../m_assets/img/slideshow-presentazione/Diapositiva5.PNG'
import Slide06 from '../m_assets/img/slideshow-presentazione/Diapositiva6.PNG'
// import Slide07 from '../m_assets/img/slideshow-presentazione/Diapositiva7.PNG'
// import Slide08 from '../m_assets/img/slideshow-presentazione/Diapositiva8.PNG'
// import Slide09 from '../m_assets/img/slideshow-presentazione/Diapositiva9.PNG'


const Presentazione = () => {
    return (
        <>
            <Card className="text-center">
                <Card.Body className="p-2">

                    <Carousel interval={null}  className="custom-carousel" >  
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide01}
                            alt="Prima slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide02}
                            alt="Seconda slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide03}
                            alt="Terza slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide04}
                            alt="Quarta slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide05}
                            alt="Quinta slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={Slide06}
                            alt="Sesta slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </Card.Body>
            </Card>
        </>
    );
};

export default Presentazione;
